import { switchProp } from 'styled-tools';
import styled from 'styled-components';
import { fontTitle, fontBody } from 'Styles/fonts';
import Icon from '../Icons/Icon';
import ButtonIconOriginal from '../Icons/ButtonIcon';

const HEADER_HEIGHT = 64;
export const SIDE_PADDING = 24;

export const SlidingPanel = styled.div`
  background: var(--background);
  height: 100%;
  position: absolute;
  width: 100%;

  transition: transform 200ms cubic-bezier(0.25, 1, 0.25, 1);

  transform: translate3d(
    ${switchProp('animationState', {
      entering: '100%',
      entered: 0,
      exiting: '100%',
      exited: '100%'
    })},
    0,
    0
  );
`;

export const ButtonIcon = styled(ButtonIconOriginal)`
  ${fontBody(20)};
  left: 8px;

  transition: opacity 200ms cubic-bezier(0.25, 1, 0.25, 1);

  opacity: ${switchProp('animationState', {
    entering: 0,
    entered: 1,
    exiting: 0,
    exited: 0
  })};
`;

export const CloseIcon = styled(ButtonIconOriginal)`
  ${fontBody(20)};
  right: 8px;
  margin: 0;
`;

export const ItemIcon = styled(Icon)`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  padding-right: inherit;
`;

export const PanelItem = styled.button`
  ${fontTitle(20)};
  position: relative;
  background: none;
  border: none;
  align-items: center;
  color: var(--foreground);
  height: 48px;
  padding: 0 ${SIDE_PADDING}px;
  text-transform: capitalize;
  display: flex;
  width: 100%;
`;

export const ChildrenContainer = styled.div`
  position: absolute;
  top: ${HEADER_HEIGHT}px;
  bottom: 0;
  width: 100%;
  overflow: hidden scroll;
`;

export const Title = styled.h1`
  ${fontTitle(20)}
  padding: 0;
  margin: 0;
  text-align: center;
  line-height: 4rem;
  vertical-align: middle;
  color: var(--foreground);
  text-transform: none;

  transition: opacity 200ms cubic-bezier(0.25, 1, 0.25, 1);

  opacity: ${switchProp('animationState', {
    entering: 0,
    entered: 1,
    exiting: 0,
    exited: 0
  })};
`;
